import { useStore } from '@/store';
import Vue from 'vue'
export default Vue.extend({
  computed: {
    signedIn() {
      return useStore().getters.isAuthenticated;
    },
    isStaff() {
      let staffGroups = ["Admin", "Worker"];
      return staffGroups.some((group) =>
        useStore().getters.getGroups.includes(group)
      );
    },
    isCustomer() {
      return useStore().getters.getGroups.includes("Customer");
    },
    userFirstName(){
      return this.$store.getters.getUser?.attributes.name.split(' ')[0];
    },
    userLastName(){
      return this.$store.getters.getUser?.attributes.name.split(' ')[1];
    },
    userFullName(){
      return this.$store.getters.getUser?.attributes.name;
    },
    customerPYBNumber(): string{
      return this.isCustomer ? this.$store.getters.getUser.attributes['custom:pybNumber'] : undefined;
    }
  },
})